import React from 'react';
import { ApolloError, useQuery } from '@apollo/client';
import WearableSleepSummaryQuery from './WearableSleepSummaryQuery';

export interface WearableSleepSummary {
  date: string;
  provider: string;
  device: string | null;
  startTime: string | null;
  endTime: string | null;
  durationMinutes: number | null;
  timeInBedMinutes: number | null;
  efficiencyPercent: number | null;
  awakeMinutes: number | null;
  lightMinutes: number | null;
  deepMinutes: number | null;
  remMinutes: number | null;
  interruptionsCount: number | null;
  napCount: number | null;
  napDurationMinutes: number | null;
  avgHeartRateBpm: number | null;
  avgHrvSdnnMs: number | null;
  avgRespiratoryRate: number | null;
  avgSpo2Percent: number | null;
}

export interface WearableSleepSummaryResult {
  loading: boolean;
  sleepSummary: WearableSleepSummary[];
  error: ApolloError | undefined;
  refetch: () => Promise<unknown>;
}

interface Props {
  dateFrom: string;
  dateTo: string;
  children: (result: WearableSleepSummaryResult) => React.ReactElement;
}

const WearableSleepSummaryConnectorApollo: React.FC<Props> = ({ dateFrom, dateTo, children }) => {
  const { loading, data, error, refetch } = useQuery(WearableSleepSummaryQuery, {
    variables: { dateFrom, dateTo },
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
  });

  return children({
    loading,
    sleepSummary: data?.wearable?.sleepSummary ?? [],
    error,
    refetch,
  });
};

export default WearableSleepSummaryConnectorApollo;
